import classNames from "classnames";
import styles from "./Options_POC.module.scss";
import { OptionsType } from "@/components/Options_POC/utils.ts";
import { Sizes } from "@JohnLewisPartnership/jl-design-system/dist/components/size/SizeList";
import Size from "@JohnLewisPartnership/jl-design-system/dist/components/size/Size";
import { useMemo } from "react";
import { ButtonSizeThreshold } from "@/components/Sizes/config/buttonSizeThresholdConfigSchema.ts";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ.ts";

type OptionsProps = {
  options: OptionsType | undefined;
  buttonSizeStyleThreshold?: ButtonSizeThreshold;
};

const cx = classNames.bind(styles);

const getKeyByThreshold = (
  number: number,
  buttonSizeStyleThreshold: ButtonSizeThreshold,
) => {
  const entry = Object.entries(buttonSizeStyleThreshold).find(
    ([, threshold]) => number <= threshold,
  );
  return entry ? entry[0] : "large";
};

export const Options_POCUI = ({
  options,
  buttonSizeStyleThreshold = {
    small: 5,
    medium: 12,
    large: 99,
  },
}: OptionsProps) => {
  const [buttonSizeStyle] = useMemo(() => {
    const longestLabel =
      options?.reduce(
        (max, option) => Math.max(max, option?.name?.length || 0),
        0,
      ) ?? 0;

    return [getKeyByThreshold(longestLabel, buttonSizeStyleThreshold)];
  }, [options, buttonSizeStyleThreshold]);

  const selectedOption = options?.find(
    (item: { isSelected: boolean }) => item.isSelected,
  );

  return (
    <div data-component="Options_POC">
      <Sizes
        key={selectedOption?.selectorValue ?? "default"}
        containerClassName={cx("optionContainer")}
        longestLabel={buttonSizeStyle}
        data-testid="options:option-size"
        selectedLabel={selectedOption?.name ?? ""}
        headingLevel={"h2"}
        label={selectedOption?.selectorTitle ?? ""}
      >
        {options?.map(
          (
            option: { name: string; isSelected: boolean; url: string },
            index: number,
          ) => (
            <Size
              className={cx("groupList")}
              key={`size-${index}`}
              id={`size-${option.name}`}
              data-testid="size:option"
              value={option.name}
              selected={option.isSelected}
              unavailable={false}
              minimiseLabelPadding={true}
              Tag="a"
              buttonProps={{
                href: option.url,
              }}
              onClick={() => {
                dispatchMonetateQEvent(
                  "standard-pdp-tv-screen-size-click-selector",
                );
              }}
            >
              {option.name}
            </Size>
          ),
        )}
      </Sizes>
    </div>
  );
};
